import React from "react"
import { Box } from "@mui/material"
import LotInventoryHubTableCP from "../components/lot-inventory-hub-table.cp"

export default function LotInventoryHubPage() {
  return (
    <Box sx={{ p: 3 }}>
      <LotInventoryHubTableCP />
    </Box>
  )
}
